var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var SGBToken = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M16.9955 13.3964L15.3424 9.92442L18.8399 8.27011L16.9955 13.3964ZM9.72236 12.8424L16.7577 13.7735L13.8895 7.7454L9.72236 12.8424ZM3.99902 23L8.27396 21.7305L9.20987 13.9361L3.99902 23ZM9.67652 13.2063L9.02615 18.635L16.5405 14.1144L9.67652 13.2063ZM9.43042 12.6355L13.6573 7.46529L5.57366 1L9.43042 12.6355ZM19.1841 8.40339L18.3323 10.7695L19.999 12.2602L19.1841 8.40339Z", fill: "#57C8E3" }))));
};
var templateObject_1;
